const API_ENDPOINTS = {
    PROFILE: "/accounts/profile/",
    GENRES: "/accounts/genres/",
    REFRESH_TOKEN: "/auth/token/refresh/",
  };
  
  export default API_ENDPOINTS;
  